import { get } from 'lodash';

import { SET_SELECTED_PAYMENT_ID, SET_SELECTED_FROM_ACCOUNT, CLEAR_SELECTED_PAYMENT } from './actions';
import { CHAPS_ADD_PAYMENTS } from '../chaps/actions';
import { BACS_ADD_MULTIPLE_PAYMENTS } from '../bacsCredit/actions';
import { RESET_APP } from '../page/actions';

const setSelectedPaymentId = (state, action) => {
	const { payments } = action;
	if (payments && payments.length === 1) {
		return {
			...state,
			selectedPaymentId: get(payments, '[0].id'),
		};
	}

	return state;
};

const payeeHandlers = {
	[SET_SELECTED_PAYMENT_ID]: (state, action) => ({
		...state,
		selectedPaymentId: action.payload,
	}),
	[SET_SELECTED_FROM_ACCOUNT]: (state, action) => {
		// Need to store the actual account details as well as just the id.
		return {
			...state,
			selectedFromAccount: action.fromAccount,
			selectedFromAccountDetails: action.fromAccountDetails,
		};
	},
	[CLEAR_SELECTED_PAYMENT]: (state) => ({
		selectedFromAccount: state.selectedFromAccountDetails,
	}),
	[CHAPS_ADD_PAYMENTS]: setSelectedPaymentId,
	[BACS_ADD_MULTIPLE_PAYMENTS]: setSelectedPaymentId,
	[RESET_APP]: () => ({}),
};

const payeeSelector = (state = {}, action) => (payeeHandlers[action.type] || ((s) => s))(state, action);

export default payeeSelector;
